module.exports = require("array-from");


//////////////////
// WEBPACK FOOTER
// external "array-from"
// module id = 4
// module chunks = 0